import { v7, v5 } from "uuid";

export function newId() {
  return v7();
}

export function newV5Id(data: string) {
  return v5(data.toString(), v5.URL);
}

export function hyphenLess(id: string) {
  return id.replaceAll("-", "");
}
